import type { IApiProductSettingsResponse, IModelDetailResponse } from './types'
import { getChromeDataApi, getJamsBackendApi } from '@/utils'

// Get product settings from JAMs
export const getProductSettings = async (
  accountId: string,
  productId: string,
): Promise<IApiProductSettingsResponse> => {
  const path = `unauth/account/products/${accountId}/${productId}`
  const endpoint = getJamsBackendApi()

  try {
    const response = await fetch(`${endpoint}/${path}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error('Could not fetch products settings.')
    }

    console.log('Response: ', response)

    const responseJson: any = await response.json()

    console.log('Response JSON: ', responseJson)

    return {
      success: true,
      data: responseJson ?? null,
    }
  } catch (err) {
    console.error(err)

    return {
      success: false,
      data: null,
    }
  }
}

// Fetch vehicle detail by model
export const fetchVehicleDetailByModel = async (
  year: number,
  make: string,
  model: string,
): Promise<IModelDetailResponse | null> => {
  try {
    const apiUrl = getChromeDataApi()
    const path = `${year}/${make}/${model}`
    console.log('>>> data', `${apiUrl}/${path}`)
    const response = await fetch(`${apiUrl}/${path}`)

    // Check if the response status is OK (200–299)
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status} - ${response.statusText}`,
      )
    }

    const data = await response.json()

    // Check if data is not as expected (e.g., empty or malformed)
    if (!data || typeof data !== 'object') {
      throw new Error('Unexpected response format')
    }

    return data
  } catch (error: any) {
    if (error instanceof TypeError) {
      // Network or CORS errors
      console.error('Network error or CORS issue:', error.message)
    } else {
      // Other errors, including non-200 responses and JSON parsing issues
      console.error(
        'An error occurred while fetching vehicle detail:',
        error?.message,
      )
    }
    // Optionally rethrow the error or return a default value
    return null
  }
}
